import { render, staticRenderFns } from "./Documentations.vue?vue&type=template&id=769e6992&scoped=true"
import script from "./Documentations.vue?vue&type=script&lang=js"
export * from "./Documentations.vue?vue&type=script&lang=js"
import style0 from "./Documentations.vue?vue&type=style&index=0&id=769e6992&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769e6992",
  null
  
)

export default component.exports